// models
export const GET_MODELS_SUCCESS = 'GET_MODELS_SUCCESS';
export const GET_MODELS_FAILURE = 'GET_MODELS_FAILURE';
export const GET_MODELS_REQUEST = 'GET_MODELS_REQUEST';
export const CLEAR_MODELS = 'CLEAR_MODELS';

// model
export const SELECT_MODEL = 'SELECT_MODEL';
export const CLEAR_SELECTED_MODEL = 'CLEAR_SELECTED_MODEL';

//brand
export const GET_MODELS_BRAND_SUCCESS = 'GET_MODELS_BRAND_SUCCESS';
export const GET_MODELS_BRAND_FAILURE = 'GET_MODELS_BRAND_FAILURE';
export const GET_MODELS_BRAND_REQUEST = 'GET_MODELS_BRAND_REQUEST';
export const CLEAR_MODELS_BRAND = 'CLEAR_MODELS_BRAND';

// pagination
export const SET_MODELS_SEARCH = 'SET_MODELS_SEARCH';
export const SET_MODELS_PAGE_SIZE = 'SET_MODELS_PAGE_SIZE';
export const NEXT_MODELS_PAGE = 'NEXT_MODELS_PAGE';
export const PREV_MODELS_PAGE = 'PREV_MODELS_PAGE';
